module.exports = __webpack_public_path__ + "static/media/download_src_2.4402c258.jpg";